var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStartupRocketSvgrepoCom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 482.2 482.2",
    style: {
      enableBackground: "new 0 0 482.2 482.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FD8469"
    },
    cx: 241.1,
    cy: 241.1,
    r: 241.1
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B3B4E"
    },
    points: "330.3,392.2 249.4,340.7 249.4,293.3 330.3,344.8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M352.7,405.9c3.2-9.5,5.2-21.8,5.2-35.2c0-30.3-10-55-22.4-55s-22.4,24.6-22.4,55 c0,13.4,2,25.7,5.2,35.2H352.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2B3B4E"
    },
    points: "151.9,392.2 232.8,340.7 232.8,293.3 151.9,344.8 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M129.5,405.9c-3.2-9.5-5.2-21.8-5.2-35.2c0-30.3,10-55,22.4-55s22.4,24.6,22.4,55 c0,13.4-2,25.7-5.2,35.2H129.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#324A5E"
    },
    d: "M287.6,363.2c46.6-93,31.1-209.2-46.5-286.8l0,0l0,0C163.5,154,148,270.2,194.6,363.2H287.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M287.8,141c-11.6-23.3-27.2-45.2-46.7-64.7l0,0l0,0c-19.5,19.5-35,41.3-46.7,64.7H287.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M258.3,405.9c3.2-9.5,5.2-21.8,5.2-35.2c0-30.3-10-55-22.4-55s-22.4,24.6-22.4,55 c0,13.4,2,25.7,5.2,35.2H258.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#84DBFF"
    },
    cx: 241.1,
    cy: 216.5,
    r: 33.5
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupRocketSvgrepoCom);
export default __webpack_public_path__ + "static/media/startup-rocket-svgrepo-com.6b7879228a94e94cc0e8cf8305f8ab9a.svg";
export { ForwardRef as ReactComponent };